import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import * as ECharts from "echarts";
import VueEcharts from "vue-echarts";
import Progress from "./components/progress/index.vue";
import {
  Popup,
  Picker,
  DatetimePicker,
  Popover,
  NoticeBar,
  Empty,
  Button,
} from "vant";
import { regFenToYuan, formatPer } from "./utils/index";

import "vue-easytable/libs/theme-default/index.css";
import { VeTable, VeLoading } from "vue-easytable";

import FastClick from "fastclick";
FastClick.attach(document.body);

import "./permission";

import "./utils/derective";

import "./styles/index.scss";

import SelectCity from "@/components/SelectCity/index";
import SelectDate from "@/components/SelectDate/index";
import VuePopover from "@/components/popover/index";
import UpDown from "@/components/UpDown/index";

Vue.use(VeTable);
Vue.use(VeLoading);
Vue.prototype.$loading = VeLoading;

Vue.config.productionTip = false;

Vue.prototype.$echarts = ECharts;
Vue.prototype.regFenToYuan = regFenToYuan;
Vue.prototype.formatPer = formatPer;

Vue.component("vue-echarts", VueEcharts);
Vue.component("vue-progress", Progress);
Vue.component("van-popup", Popup);
Vue.component("van-picker", Picker);
Vue.component("van-datetime-picker", DatetimePicker);
Vue.component("van-popover", Popover);
Vue.component("van-empty", Empty);
Vue.component("van-button", Button);
Vue.component("van-noticeBar", NoticeBar);
Vue.component("select-city", SelectCity);
Vue.component("select-date", SelectDate);
Vue.component("popover", VuePopover);
Vue.component("up-down", UpDown);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
